// Two-pane pickers with a fixed height; the width comes from `size="xl"`.
const dialogContentStyle = "h-[75vh] flex flex-col px-0";
const dialogHeaderStyle = "px-6";
const dialogDescriptionStyle = "flex-1 min-h-0";
const dialogDescriptionWrapperStyle = "flex flex-col h-full";
const userListParentWrapperStyle =
  "grid grid-cols-1 lg:grid-cols-2 flex-1 min-h-0 overflow-hidden";
const userListCardWrapperLeft =
  "flex flex-col h-full overflow-hidden pl-6 pr-6 lg:pr-3";
const userListCardWrapperRight =
  "flex flex-col h-full overflow-hidden pr-6 pl-6 lg:pl-3";
const userListCardStyle =
  "flex flex-col shadow-[0px_2px_6px_1.5px_rgba(0,0,0,0.1)] rounded-lg my-2 gap-2 h-full overflow-hidden";
const userListCardHeaderStyle =
  "flex flex-row justify-between items-center relative p-2 border-b";
const userListCardHeaderTitleTextStyle = "text-sm pl-2 flex-1";
const userListCardHeaderTitleTooltipStyle = "text-sm";
const inputStyle = "w-1/2 h-8 pr-8";
const userListCardHeaderAbsoluteButtonWrapperStyle =
  "absolute right-2 top-0 h-full flex items-center justify-center";
const userListCardHeaderAbsoluteButtonStyle =
  "p-2 hover:bg-transparent opacity-50 hover:opacity-100 transition-opacity duration-200";
const userListComponentStyle = "flex-1 min-h-0 mb-2";
const userListComponentEmptyStyle =
  "text-lg text-muted-foreground flex flex-1 justify-center items-center xl:h-[30vh] h-[20vh]";

const dialogFooterStyle = "flex flex-row justify-end px-6";
const dialogFooterButtonStyle = "px-8";
export {
  dialogContentStyle,
  dialogHeaderStyle,
  dialogDescriptionStyle,
  dialogDescriptionWrapperStyle,
  userListParentWrapperStyle,
  userListCardWrapperLeft,
  userListCardWrapperRight,
  userListCardStyle,
  userListCardHeaderStyle,
  userListCardHeaderTitleTextStyle,
  userListCardHeaderTitleTooltipStyle,
  inputStyle,
  userListCardHeaderAbsoluteButtonWrapperStyle,
  userListCardHeaderAbsoluteButtonStyle,
  userListComponentStyle,
  userListComponentEmptyStyle,
  dialogFooterStyle,
  dialogFooterButtonStyle,
};
